import { overlay } from 'overlay-kit';
import type { SaveQuizTarget, SaveToFolderOptions } from './types/saveQuizLocation.types';

/**
 * `내 퀴즈로 저장` 의 저장 위치 선택 모달을 연다.
 *
 * 퀴즈 상세·자료실·검색 어디서든 열 수 있게 도메인에 둔다 — 저장은 특정 화면의 기능이 아니라
 * "퀴즈를 발견한 자리"의 기능이다.
 *
 * **무엇을 할지는 부르는 쪽이 `intent` 로 정한다** — 같은 모달이지만 `복사` 로 들어오면 사본을
 * 만들고 `폴더 이동` 으로 들어오면 소속만 바꾼다. 소유권으로 추론하지 않는다.
 *
 * `options` 로 목적에 따라 좁힌다 — 빌드 설정의 `비공개로 바꾸려면 먼저 옮기기` 처럼 갈 수 있는
 * 곳이 제한된 흐름이 있다(`privateOnly`).
 */
export async function showSaveToFolderModal(quiz: SaveQuizTarget, options?: SaveToFolderOptions) {
  const {
    SaveToFolderModal
  } = await import('./components/SaveToFolderModal');
  overlay.open(({
    unmount
  }) => <SaveToFolderModal quiz={quiz} options={options} onClose={unmount} />, {
    overlayId: 'save-to-folder-modal'
  });
}